import React from 'react';
import { FaUser } from 'react-icons/fa';

export function NewDMModal({ isOpen, onClose, familyMembers, onSelectMember }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center px-4 z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6" data-testid="new-dm-modal">
        <h3 className="text-xl font-bold text-gray-800 mb-4">New Message</h3>
        <p className="text-gray-600 mb-4">Select a family member to message</p>
        
        {familyMembers.length === 0 ? (
          <p className="text-gray-500 text-center py-4">No family members available</p>
        ) : (
          <div className="space-y-2 max-h-64 overflow-y-auto">
            {familyMembers.map((member) => (
              <button
                key={member.user_id}
                onClick={() => onSelectMember(member)}
                className="w-full p-3 text-left rounded-lg hover:bg-blue-50 flex items-center space-x-3 transition"
                data-testid={`dm-member-${member.user_id}`}
              >
                <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center text-purple-600">
                  <FaUser />
                </div>
                <div>
                  <p className="font-medium text-gray-800">{member.name}</p>
                  <p className="text-sm text-gray-500">{member.email}</p>
                </div>
              </button>
            ))}
          </div>
        )}
        
        <div className="mt-4 pt-4 border-t border-gray-200">
          <button
            onClick={onClose}
            className="w-full px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
